import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CargoService } from 'src/app/service/cargo.service';
import { aplicarFiltrosConsulta } from 'src/app/util/consulta/wow-consulta.util';
import { Cargo } from './cargo';

@Component({
  selector: 'app-cargo-consulta',
  templateUrl: './cargo-consulta.component.html',
  styleUrls: [
    './cargo-shared.scss',
    '../../util/conta-financeira/conta-financeira-consulta.scss',
  ],
})
export class CargoConsultaComponent {

  cargos: Cargo[] = [];
  tipoFiltros = ['ID', 'Nome', 'Departamento'];
  tipoFiltro = 'ID';
  parametro = '';
  situacao: boolean | null = null;
  consultaRealizada = false;

  constructor(
    private service: CargoService,
    private snackBar: MatSnackBar,
    private router: Router,
  ) { }

  consultar() {
    this.service.listar().subscribe(lista => {
      this.cargos = aplicarFiltrosConsulta(lista ?? [], this.tipoFiltro, this.parametro, this.situacao, {
        id: c => c.id,
        nome: c => this.tipoFiltro === 'Departamento' ? c.departamentoNome : c.nome,
        ativo: c => c.ativo !== false,
      });
      this.consultaRealizada = true;
    }, () => this.snackBar.open('Erro ao listar cargos.', 'ERRO', { duration: 2500 }));
  }

  novo() {
    this.router.navigate(['/cargo/form']);
  }

  editar(item: Cargo) {
    if (item.id) {
      this.router.navigate(['/cargo/form', item.id]);
    }
  }

  inativar(item: Cargo) {
    if (!item.id || !confirm('Inativar este cargo?')) {
      return;
    }
    this.service.inativar(item.id).subscribe(() => {
      this.snackBar.open('Cargo inativado.', 'OK', { duration: 2000 });
      this.consultar();
    });
  }
}
